"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgPinOff = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_PIN-OFF", width: "1em", height: "1em", viewBox: "0 0 15 16" }, props),
    React.createElement("path", { d: "M3.332 7.676 5.68 6.32 4.383 1.999h5.322L8.98 4.415l2.525-1.458.495-1.65A1.015 1.015 0 0 0 11.029 0H3.06c-.68 0-1.168.655-.973 1.306l1.638 5.459-.393.91ZM.502 10.467a1 1 0 0 0 1 1.732l3.808-2.198.694.002.457 5.49a.54.54 0 0 0 1.078 0l.468-5.49 3.008-.007a.507.507 0 0 0 .47-.7l-1.01-2.277 3.031-1.75a1 1 0 1 0-1-1.732L.502 10.467Zm8.28-2.47h.003v-.002l-.004.002Z" }))); };
exports.default = SvgPinOff;
